import restClient from 'Shared/hooks/restClient'
import brand from './brand'
import local from './local'

const actionSlices = {
  brand,
  local,
}

export default () => {
  const dis = useDis()
  const store = useStore()

  return useMemo(
    () => _.mapValues(actionSlices, (fn) => {
      return fn(dis, store, restClient)
    }),
    []
  )
}
